/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Page_Icon_FileexceliconInputs */

const en_enum_custom_page_icon_fileexcelicon = /** @type {(inputs: Enum_Custom_Page_Icon_FileexceliconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Excel`)
};

const de_enum_custom_page_icon_fileexcelicon = /** @type {(inputs: Enum_Custom_Page_Icon_FileexceliconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excel-Datei`)
};

/**
* | output |
* | --- |
* | "File Excel" |
*
* @param {Enum_Custom_Page_Icon_FileexceliconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_page_icon_fileexcelicon = /** @type {((inputs?: Enum_Custom_Page_Icon_FileexceliconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Page_Icon_FileexceliconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_page_icon_fileexcelicon(inputs)
	return de_enum_custom_page_icon_fileexcelicon(inputs)
});